export const tableHeader = ['Fixture', 'Home Team', 'Away Team', 'Date', 'Score', 'Result'];

export const tableHeaderCricket = [
  'Fixture',
  'Home Team',
  'Away Team',
  'Toss',
  'Date',
  'Score',
  'Result',
];

export const divHeader = ['DIV', 'Matches', 'Number of Winners', 'Payout per Winner'];

export const tossResultsHeader = ['DIV', 'Toss Results', 'Number of Winners', 'Payout per Winner'];
